import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// react-snap rendert die Seiten vor – inklusive der aus der API geladenen Inhalte, damit
// Suchmaschinen sie im HTML finden. Im Browser startet die App ohne diese Daten, eine Hydration
// würde daher abweichen (React-Fehler #418). Deshalb wird das vorgerenderte HTML ersetzt.
ReactDOM.createRoot(rootElement).render(app);
